import moment from 'moment';

export default class ShippingContact {
    private _id: string;
    private _replacementListCandidateId: string;
    private _jobPositionId: string;
    private _candidateToken: string;
    private _responseDate: moment.Moment;
    private _order: number;
    private _fullName: string;
    private _nif: string;

    public constructor(data: any) {
        this._id = data.id;
        this._replacementListCandidateId = data.replacementListCandidateId;
        this._jobPositionId = data.jobPositionId;
        this._candidateToken = data.candidateToken;
        this._responseDate = moment.utc(data.responseDate).local();
        this._order = data.order;
        this._fullName = data.fullName;
        this._nif = data.nif;
    }

    public get id() {
        return this._id;
    }

    public get replacementListCandidateId() {
        return this._replacementListCandidateId;
    }

    public get jobPositionId() {
        return this._jobPositionId;
    }

    public get candidateToken() {
        return this._candidateToken;
    }

    public get responseDate() {
        return this._responseDate;
    }

    public get order() {
        return this._order;
    }

    public get fullName() {
        return this._fullName;
    }

    public get nif() {
        return this._nif;
    }
}
